import { render, staticRenderFns } from "./TouchpointStatisticsOverviewCell.vue?vue&type=template&id=911b7a98&"
import script from "./TouchpointStatisticsOverviewCell.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOverviewCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('911b7a98')) {
      api.createRecord('911b7a98', component.options)
    } else {
      api.reload('911b7a98', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOverviewCell.vue?vue&type=template&id=911b7a98&", function () {
      api.rerender('911b7a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsOverviewCell.vue"
export default component.exports